import React from "react"
import IconButton from "@mui/material/IconButton"
import Stack from "@mui/material/Stack"
import TextField from "@mui/material/TextField"
import Typography from "@mui/material/Typography"
import NavigateNextIcon from "@mui/icons-material/NavigateNext"
import NavigateBeforeIcon from "@mui/icons-material/NavigateBefore"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import Box from "@mui/material/Box"

const CustomTablePagination = ({ page, totalPages, setPage }: any) => {
  const dispatch = useDispatch()

  return (
    <Stack sx={{ mt: "20px" }} width="100%">
      {totalPages ? (
        <Stack
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={"2px"}
        >
          <Typography>
            {page} из {totalPages}
          </Typography>

          <IconButton
            onClick={() => dispatch(setPage(page - 1))}
            aria-label="previous"
            disabled={page === 1}
            size="small"
          >
            <NavigateBeforeIcon />
          </IconButton>
          <TextField
            value={page}
            sx={{
              ".MuiOutlinedInput-input": {
                p: 0,
                mx: "10px",
                width: "24px",

                textAlign: "center",
              },
            }}
          />
          <IconButton
            onClick={() => dispatch(setPage(page + 1))}
            aria-label="next"
            size="small"
            disabled={page === totalPages}
          >
            <NavigateNextIcon />
          </IconButton>
        </Stack>
      ) : (
        <Box sx={{ height: "34px" }}></Box>
      )}
    </Stack>
  )
}

export default CustomTablePagination
